import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { trainwellColor } from "src/theme/themePrimitives";

export const StyledImageContainer = styled(Box)(({ theme }) => ({
  width: "240px",
  height: "240px",
  position: "relative",
  borderRadius: theme.spacing(3),
  overflow: "hidden",
  border: `4px solid ${trainwellColor.neutral3}`,
}));
